module.exports = __webpack_public_path__ + "static/media/signUpConfirm.ccbe7920.svg";